/**
 * Public API
 */
 module.exports = {
	claims: (item) => {
        let detailRowsHTML = `
        <div class="row">
            <div class="cel _hide_sm_up cel--column">
                <div>${item.member}</div>
                <div><span class="-header">Claim Id</span> ${item.claim_id}</div>
                <div><span class="-header">Insurance Id</span> ${item.insurance_id}</div>
                <div><span class="-header">Service Date</span> ${item.service_date}</div>
            </div>
            <div class="cel _hide_xs">${item.member}</div>
            <div class="cel _hide_xs">${item.claim_id}</div>
            <div class="cel _hide_xs">${item.insurance_id}</div>
            <div class="cel _hide_xs">${item.date_of_service}</div>
            <div class="cel"><div class="cel__status ${item.status === 'Denied' ? 'err' : ''}">${item.status}</div> <i class="icon icon-plus bubble expand-row"></i></div>
            <section class="detail">
                <header class="detail__header">
                    <div class="detail__header__col">
                        <span class="-header">Billed Amount</span><span class="-emphasis -dollar">${item.billed_amount_total}</span>
                    </div>
                    <div class="detail__header__col">
                        <span class="-header">Plan Paid</span><span class="-emphasis -dollar">${item.plan_paid_total}</span>
                    </div>
                    <div class="detail__header__col">
                        <span class="-header">Member Liability</span><span class="-emphasis -dollar">${item.member_liability_total}</span>
                    </div>
                    <div class="detail__header__col">
                        <span class="-header">Paid Date</span><span class="-emphasis">${item.paid_date}</span>
                    </div>
                </header>
        `;
        $.each(item.detail, function(key, subItem) {
            detailRowsHTML += `
                <div class="row -break-xxl detail__row">
                    <div class="detail__col">
                        <h4 class="title detail__title">Line of Business</h4>
                        <h4 class="subtitle detail__subtitle">${item.line_of_business}</h4>
                        <ul class="detail__list">
                            <li class="listitem"><span class="-header -bold">Service Line Number</span><span>${subItem.claim_line_id}</span></li>
                            <li class="listitem"><span class="-header -bold">Service Description</span><span>${subItem.procedure_code_desc}</span></li>
                            <li class="listitem"><span class="-header -bold">Service Code</span><span>${subItem.procedure_code}</span></li>
                            <li class="listitem"><span class="-header -bold">Provider Name</span><span>${subItem.provider_name}</span></li>
                            <li class="listitem"><span class="-header -bold">Supplier Name</span><span>${item.supplier_name}</span></li>
                            <li class="listitem"><span class="-header -bold">Supplier Payee Name</span><span>${item.supplier_payee_name}</span></li>
                        </ul>
                    </div>
                    <div class="detail__col detail__list--wide">
                        <div class="listitem -provider -supplier"><span class="-header -bold">Claim Line Status</span><span>${subItem.claim_line_status}</span></div>
                        <div class="listitem"><span class="-header -bold">Billed Amount</span><span class="-dollar">${subItem.billed_amount}</span></div>
                        <div class="listitem"><span class="-header -bold">Paid Amount</span><span class="-dollar">${subItem.paid_amount}</span></div>
                    </div>
                </div>`;
        });

        return detailRowsHTML + '</section></div>';

    },
	authorizations: (item) => {
        let detailRowsHTML = `
        <div class="row">
            <div class="cel _hide_sm_up cel--column">
                <div>${item.member}</div>
                <div><span class="-header">Auth Id</span> ${item.auth_id}</div>
                <div><span class="-header">Insurance Id</span> ${item.insurance_id}</div>
            </div>
            <div class="cel _hide_xs">${item.member}</div>
            <div class="cel _hide_xs">${item.auth_id}</div>
            <div class="cel _hide_xs">${item.insurance_id}</div>
            <div class="cel">${item.date_of_service} <i class="icon icon-plus bubble expand-row"></i></div>
            <section class="detail">`;
            $.each(item.detail, function(key, subItem) {
                detailRowsHTML += `
                <div class="row -break-xxl detail__row">
                <div class="detail__col">
                    <h4 class="title detail__title">${subItem.line_of_business}</h4>
                    <h4 class="subtitle detail__subtitle">${subItem.date_of_service}</h4>
                    <ul class="detail__list">
                        <li class="listitem"><span class="-header -bold">Service Line Number</span><span>${subItem.service_line_number}</span></li>
                        <li class="listitem"><span class="-header -bold">Service Description</span><span>${subItem.service_desc}</span></li>
                        <li class="listitem"><span class="-header -bold">Service Code</span><span>${subItem.service_code}</span></li>
                        <li class="listitem"><span class="-header -bold">Status</span><span>${subItem.status}</span></li>
                        <li class="listitem"><span class="-header -bold">Practice Group</span><span>${subItem.supplier_name}</span></li>
                        <li class="listitem"><span class="-header -bold">Referring Supplier</span><span>${item.referring_supplier_name}</span></li>
                        <li class="listitem"><span class="-header -bold">Referring Provider</span><span>${item.referring_provider_name}</span></li>
                        <li class="listitem"><span class="-header -bold">Refer-To Supplier</span><span>${subItem.refer_to_supplier_name}</span></li>
                        <li class="listitem"><span class="-header -bold">Refer-To Provider</span><span>${subItem.refer_to_provider_name}</span></li>
                    </ul>
                </div>
                <div class="detail__col detail__list--wide">
                    <div class="listitem"><span class="-header -bold">Approval Count</span><span>${subItem.approval_count}</span></div>
                    <div class="listitem"><span class="-header -bold">Approval Units</span><span>${subItem.approval_units}</span></div>
                </div>
            </div>`;
            });
        return detailRowsHTML + '</section></div>';
    },
	eligibility: (item) => {
        return `
        <div class="row">
            <div class="cel _hide_sm_up cel--column">
                <div>${item.member}</div>
                <div><span class="-header">Member DOB</span> ${item.claim_id}</div>
                <div><span class="-header">Insurance ID</span> ${item.insurance_id}</div>
            </div>
            <div class="cel _hide_xs">${item.member}</div>
            <div class="cel _hide_xs">${item.member_dob}</div>
            <div class="cel _hide_xs">${item.insurance_id}</div>
            <div class="cel"><span>${item.effective_date} - ${item.term_date}</span> <i class="icon icon-plus bubble expand-row"></i></div>
            <section class="detail">
                <div class="row detail__row -break-sm">
                    <div class="detail__col">
                        <h4 class="title detail__title">${item.line_of_business}</h4>
                        <ul class="detail__list">
                            <li class="listitem"><span class="-header -bold">Primary Care Physician</span><span>${item.provider}</span></li>
                        </ul>
                    </div>
                    <div class="detail__col"></div>
                </div>
            </section>
        </div>
        `;
    },
	'pcp-panel': (item) => {
        return `
        <div class="row">
            <div class="cel _hide_sm_up cel--column">
                <div>${item.member}</div>
                <div><span class="-header">Member DOB</span> ${item.member_dob}</div>
                <div><span class="-header">Insurance ID</span> ${item.member_gender}</div>
            </div>
            <div class="cel _hide_xs">${item.member}</div>
            <div class="cel _hide_xs">${item.member_dob}</div>
            <div class="cel _hide_xs">${item.member_gender}</div>
            <div class="cel"><div>${item.insurance_id}</div> <i class="icon icon-plus bubble expand-row"></i></div>
            <section class="detail">
                <div class="row -break-sm detail__row">
                    <div class="detail__col">
                        <h4 class="title detail__title">Line of Business</h4>
                        <h4 class="subtitle detail__subtitle">${item.line_of_business}</h4>
                        <ul class="detail__list">
                            <li class="listitem"><span class="-header -bold">Provider</span><span>${item.provider}</span></li>
                            <li class="listitem"><span class="-header -bold">Supplier</span><span>${item.supplier_name}</span></li>
                        </ul>
                    </div>
                    <div class="detail__col"></div>
                </div>
            </section>
        </div>
        `;
    },
    'care-plans': (item) => {
        return `
        <div class="row">
            <div class="cel _hide_sm_up cel--column">
                <div>${item.member}</div>
                <div>${item.insurance_id}</div>
            </div>
            <div class="cel _hide_xs">${item.member}</div>
            <div class="cel _hide_xs">${item.insurance_id}</div>
            <div class="cel"><div class="btn download" data-file="${item.file_name}">Download <i class="icon icon-download"></i></div></div>
        </div>
        `;
    },
    'users-providers': (item) => {
        let detailRowsHTML = `
        <div class="row users">
            <div class="cel _hide_sm_up cel--column">
                <div><span class="-header">NPI</span>${item.npi}</div>
                <div><span class="-header">TAX ID</span> ${item.supplier_tax_id}</div>
                <div><span class="-header">Type</span> ${item.type}</div>
                <div><span class="-header">Name</span> ${item.name}</div>
                <div><span class="-header">Email</span> ${item.user_email}</div>
                <div><span class="-header">Account Created</span> ${item.user_registered}</div>
                <div><span class="-header">Last Login</span> ${item.last_login}</div>
                <div><span class="-header">Phone</span> ${item.phone_number}</div>
                <div><span class="-header">Address</span> ${item.address}</div>
            </div>
            <div class="cel _hide_xs">${item.npi}</div>
            <div class="cel _hide_xs">${item.supplier_tax_id}</div>
            <div class="cel _hide_xs">${item.type}</div>
            <div class="cel _hide_xs">${item.name}</div>
            <div class="cel _hide_xs">${item.user_email}</div>
            <div class="cel _hide_xs">${item.user_registered}</div>
            <div class="cel _hide_xs">${item.last_login}</div>
            <div class="cel _hide_xs">${item.phone_number}</div>
            <div class="cel _hide_xs">${item.address}</div>
            <section class="detail">
        `;
        $.each(item.detail, function(key, subItem) {
            detailRowsHTML += `
                <div class="row -break-xxl detail__row">
                    <div class="detail__col">
                        <h4 class="title detail__title">Line of Business</h4>
                        <h4 class="subtitle detail__subtitle">${item.line_of_business}</h4>
                        <ul class="detail__list">
                            <li class="listitem"><span class="-header -bold">Service Line Number</span><span>${subItem.claim_line_id}</span></li>
                            <li class="listitem"><span class="-header -bold">Service Description</span><span>${subItem.procedure_code_desc}</span></li>
                            <li class="listitem"><span class="-header -bold">Service Code</span><span>${subItem.procedure_code}</span></li>
                            <li class="listitem"><span class="-header -bold">Provider Name</span><span>${subItem.provider_name}</span></li>
                            <li class="listitem"><span class="-header -bold">Supplier Name</span><span>${item.supplier_name}</span></li>
                            <li class="listitem"><span class="-header -bold">Supplier Payee Name</span><span>${item.supplier_payee_name}</span></li>
                        </ul>
                    </div>
                    <div class="detail__col detail__list--wide">
                        <div class="listitem -provider -supplier"><span class="-header -bold">Claim Line Status</span><span>${subItem.claim_line_status}</span></div>
                        <div class="listitem"><span class="-header -bold">Billed Amount</span><span class="-dollar">${subItem.billed_amount}</span></div>
                        <div class="listitem"><span class="-header -bold">Paid Amount</span><span class="-dollar">${subItem.paid_amount}</span></div>
                    </div>
                </div>`;
        });

        return detailRowsHTML + '</section></div>';

    },
};



// WEBPACK FOOTER //
// ./scripts/components/data-table-html.js